import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import ProfileView from "../views/ProfileView.vue";
import GoalsView from "../views/GoalsView.vue";
import TermineView from "../views/TermineView.vue";
import ProjectsDetailView from "../views/ProjectsDetailView.vue";
import DatenschutzView from "../views/DatenschutzView.vue";
import ImpressumView from "../views/ImpressumView.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/profile",
    name: "profile",
    component: ProfileView,
  },
  {
    path: "/goals",
    name: "goals",
    component: GoalsView,
  },
  {
    path: "/termine",
    name: "termine",
    component: TermineView,
  },
  {
    path: "/projects",
    name: "projects",
    component: ProjectsDetailView,
  },
  {
    path: "/datenschutz",
    name: "datenschutz",
    component: DatenschutzView,
  },
  {
    path: "/impressum",
    name: "impressum",
    component: ImpressumView,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: "smooth",
      };
    }
    return { top: 0, behavior: "smooth" };
  },
});

export default router;
